module.exports = __webpack_public_path__ + "assets/img/document-copy 1.4440b5b4.svg";